import axios from 'axios'
import { useMutation, useQuery } from '@tanstack/react-query'

export const useGetImages = () => {

  const request = async (): Promise<{
    images: string[],
    next_start_after: string
  }> => {
    const response = await axios.get('https://api-staging.siai.live/api/asset/asset/')

    return response.data
  }

  const { data: landingGallery } = useQuery({
    queryKey: ["landing-gallery"],
    queryFn: request,
  })

  return { landingGallery }
}

export const useSetNextImage = (setValues: (data: {images: string[], next: string | null}) => void) => {

  const request = async (next: string | null): Promise<{
    images: string[],
    next_start_after: string | null,
  }> => {
    const response = await axios.post('https://api-staging.siai.live/api/asset/asset/', { start_after: next });
    return response.data
  }

  const { mutate: setNewImages, status } = useMutation({
    mutationFn: request,
    onSuccess: (data) => {
      setValues({ images: data.images, next: data.next_start_after })
    }
  })

  return { setNewImages, status }
}
